const Embajadores = () => {
    return (
        <main className = "mainSubs">
            <h1>Embajadores Descripcion</h1>
        </main>
    )
}

export default Embajadores
